import { inject, InjectionToken, signal } from '@angular/core';

export type ENCRYPTION_MODE_TYPE = {
    get: () => 0 | 1;
    set: (mode: 0 | 1) => void;
}


export const ENCRYPTION_MODE = new InjectionToken<ENCRYPTION_MODE_TYPE>('ENCRYPTION_MODE', {
    providedIn: 'root',
    factory: () => {
        // const _StorageService = inject(StorageService);
        let mode: 0 | 1 = Number(sessionStorage.getItem('evulaVtpyrcne')) === 1 ? 1 : 0;
        const _mode = signal<0 | 1>(mode);
        return {
            get: () => _mode(),
            set: (mode: 0 | 1) => {
                _mode.set(mode);
                sessionStorage.setItem('evulaVtpyrcne', JSON.stringify(mode));
            }
        };
    }
});
